module.exports = __webpack_public_path__ + "static/media/banner1.748b9a0b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/supplier/ebs/images/banner1.jpg
// module id = 577
// module chunks = 0